import styled from 'styled-components'

export type LoaderType = {
  $inline?: boolean
  position?: 'left' | 'center' | 'right'
}
export const Wrapper = styled.div<LoaderType>`
  display: ${({ $inline }) => $inline ? 'inline' : 'block'};
  text-align: ${({ position }) => position || 'center'};
  padding: 1rem;
`
